<template lang="html">
  <div>
    <table width="100%">
    	<tr>
    		<td colspan="2"><h1>{{student.firstname}} {{student.lastname}}</h1></td>
    	</tr>
      <tr>
       <th>Name</th>
       <td>{{student.lastname}}</td>
      </tr>
      <tr>
       <th>Vorname</th>
       <td>{{student.firstname}}</td>
      </tr>
    	<tr v-if="student.origin">
    	 <th>Herkunftsort</th>
    	 <td>{{student.origin}}</td>
    	</tr>
      <tr v-if="student.notes">
       <th>Bemerkungen</th>
       <td>{{student.notes}}</td>
      </tr>
    </table>

    <table width="100%" v-if="student.hasRegistrations">
      <tr>
        <td colspan="3"><h1>Immatrikulationen</h1></td>
      </tr>
      <tr>
        <th>Semester</th>
        <th>Fakultät/Fach</th>
        <th>Datum</th>
      </tr>
      <tr v-for="item in student.registrations">
        <td>{{item.semester_name}}</td>
        <td>{{item.faculty}}</td>
        <td>{{item.date}}</td>
      </tr>
    </table>

    <table width="100%" v-if="student.hasRecords">
      <tr>
        <td colspan="2"><h1>Belege</h1></td>
      </tr>
      <tr>
        <th>Quelle</th>
        <th>Details</th>
      </tr>
      <tr v-for="item in student.records">
        <td>{{item.source}}</td>
        <td>{{item.details}}</td>
      </tr>
      <tr class="noprint">
        <td colspan="2"><hr size="1"></td>
      </tr>
      <tr class="noprint">
        <td colspan="2">
          <ul>
            <li><router-link to="sources">Bio-bibliographische Nachweise</router-link></li>
          </ul>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  // beforeRouteUpdate (to, from, next) {
  //   this.getStudent(to.params.id).then(
  //     success => { this.student = this.studentById(to.params.id) },
  //     error => console.log(error)
  //   )
  //   next()
  // },
  computed: {
    ...mapGetters(['studentById'])
  },
  created () {
    this.getStudent({id: this.id}).then(
      success => { this.student = this.studentById(this.id) },
      error => console.log(error)
    )
  },
  data () {
    return {
      student: {}
    }
  },
  methods: {
    ...mapActions(['getStudent'])
  },
  props: {
    id: { required: true }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// Student.vue?6bad02a1